import React, { useState } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { useQuery } from "react-query";
import { searchCandidates } from "../../api/services/candidate";
import { QK } from "../../base/qk";

const EmployeeSearch = ({ label, value, onChange, required = false }) => {
  const [inputValue, setInputValue] = useState("");

  const { data: options = [], isFetching } = useQuery(
    [QK.candidates, inputValue],
    () => searchCandidates(inputValue),
    {
      enabled: !!inputValue,
      keepPreviousData: true,
    }
  );

  const getOptionLabel = (option) => {
    if (!option) return "";
    return `${option.first_name} ${option.last_name} (${option.department || "No Department"})`;
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      isOptionEqualToValue={(option, val) => option.id === val?.id}
      loading={isFetching}
      noOptionsText={
        inputValue.length > 0
          ? "No employees match your search"
          : "Type to search employees"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching ? <CircularProgress color="primary" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default EmployeeSearch;